var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 40C31.0364 40 39.9907 31.0457 39.9907 20C39.9907 8.9543 31.0364 0 19.9907 0C8.94506 0 -0.00924683 8.9543 -0.00924683 20C-0.00924683 31.0457 8.94506 40 19.9907 40Z",
    fill: "url(#paint0_linear_3699_1399)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.66 22.0404H32.6648C32.1493 22.74 31.3096 23.187 30.3693 23.1563C28.9181 23.1093 27.7433 21.9122 27.7222 20.4607C27.7 18.9326 28.9367 17.6822 30.4596 17.6822C31.4859 17.6822 32.3819 18.2504 32.8507 19.0881H35.6607C35.8852 19.0881 36.043 18.8693 35.9745 18.6556C35.2259 16.3233 33.037 14.6307 30.4596 14.6307C27.1889 14.6307 24.5426 17.3574 24.6752 20.657C24.7959 23.6693 27.2422 26.1015 30.2552 26.2059C32.8444 26.2956 35.0752 24.6748 35.9044 22.3878C35.9656 22.2189 35.8396 22.0404 35.66 22.0404Z",
    fill: "url(#paint1_linear_3699_1399)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M28.4037 25.8308C28.6019 24.7323 28.7559 23.6637 28.8745 22.646C28.1885 22.1545 27.7352 21.3567 27.7222 20.4604C27.7063 19.38 28.3211 18.4411 29.2204 17.9819C29.2659 16.5945 29.2511 15.4826 29.2285 14.763C27.0319 15.2408 25.2963 16.9686 24.8082 19.1615L24.76 21.4323C25.1182 23.4519 26.5308 25.1152 28.4037 25.8308Z",
    fill: "url(#paint2_linear_3699_1399)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6744 16.3293L11.7159 22.3563C11.22 22.8523 10.5356 23.1593 9.78113 23.1593V26.2108C11.3771 26.2108 12.8248 25.5615 13.873 24.5134L18.8315 18.4867C19.3274 17.9908 20.0118 17.6837 20.7667 17.6837V14.6323C19.1704 14.6319 17.723 15.2812 16.6744 16.3293Z",
    fill: "url(#paint3_linear_3699_1399)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.6744 16.3297L11.7159 22.3563C11.22 22.8523 10.5356 23.1593 9.78113 23.1593V26.2108C11.3771 26.2108 12.8248 25.5615 13.873 24.5134L18.8315 18.4867C19.3274 17.9908 20.0118 17.6837 20.7667 17.6837V14.6323C19.1704 14.6319 17.723 15.2815 16.6744 16.3297Z",
    fill: "url(#paint4_linear_3699_1399)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7996 14.6648C28.0478 14.8634 26.5304 15.8467 25.6089 17.2537C24.5737 15.6763 22.79 14.6319 20.7667 14.6319V17.6834C21.5215 17.6834 22.2059 17.9904 22.7015 18.4863C23.1974 18.9822 23.5045 19.6667 23.5045 20.4215C23.5045 21.1763 23.1974 21.8608 22.7015 22.3567C22.2056 22.8522 21.5211 23.1597 20.7667 23.1597C20.0119 23.1597 19.327 22.8526 18.8315 22.3567C18.3359 21.8608 18.0289 21.1763 18.0289 20.4215V15.3215C18.0289 14.9378 18.0289 14.5685 18.0289 14.2311C18.0289 11.9426 14.9774 12.2008 14.9774 12.2008V20.2519H14.98C14.9782 20.3082 14.9774 20.3645 14.9774 20.4211C14.9774 23.6134 17.5745 26.2104 20.7667 26.2104C22.7933 26.2104 24.5789 25.1626 25.6133 23.5815C25.6137 23.5819 25.6137 23.5822 25.6141 23.5826C26.0804 22.8815 26.5267 21.9778 26.9963 20.7874C27.4363 19.6719 28.0352 18.6897 28.9885 18.1059C29.0641 18.0578 29.1422 18.0134 29.2226 17.9726C30.05 17.5322 30.4467 17.5908 30.4552 17.59L30.6296 14.6426C30.5611 14.6459 30.2559 14.6208 29.7996 14.6648Z",
    fill: "url(#paint5_linear_3699_1399)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78074 14.6319C8.18482 14.6319 6.73704 15.2812 5.68889 16.3297C4.64075 17.3778 3.99149 18.8252 3.99149 20.4215C3.99149 22.0178 4.64075 23.4649 5.68889 24.5134C6.73704 25.5619 8.18445 26.2108 9.78074 26.2108V23.1593C9.02593 23.1593 8.34148 22.8523 7.84593 22.3563C7.35 21.8604 7.04297 21.176 7.04297 20.4212C7.04297 19.6663 7.35 18.9819 7.84593 18.486C8.34185 17.99 9.0263 17.683 9.78074 17.683C10.5352 17.683 11.22 17.99 11.7156 18.486C12.2115 18.9819 12.5185 19.6663 12.5185 20.4212V23.1623C12.5185 23.546 12.5185 23.8345 12.5185 24.1719C12.5185 26.4604 15.57 26.2023 15.57 26.2023V20.4212C15.57 18.8249 14.9207 17.3778 13.8726 16.3293C12.8244 15.2812 11.377 14.6319 9.78074 14.6319Z",
    fill: "url(#paint6_linear_3699_1399)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3699_1399",
    x1: -0.00924683,
    y1: 20,
    x2: 38.943,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3699_1399",
    x1: 1.60893,
    y1: 20.42,
    x2: 35.128,
    y2: 20.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3699_1399",
    x1: 22.8122,
    y1: 18.4031,
    x2: 29.509,
    y2: 20.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5698,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3699_1399",
    x1: 1.60897,
    y1: 20.4213,
    x2: 35.128,
    y2: 20.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3699_1399",
    x1: 9.78077,
    y1: 20.4215,
    x2: 20.0111,
    y2: 20.4215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7465,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3699_1399",
    x1: 1.60894,
    y1: 19.2013,
    x2: 35.128,
    y2: 19.2013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3699_1399",
    x1: 1.60895,
    y1: 20.4215,
    x2: 35.128,
    y2: 20.4215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.484c4b8f6e2906a250052854d7cd6ad1.svg";
export { ForwardRef as ReactComponent };